import React from 'react';
import GeneralForm from './edit/GeneralForm';
import ExerciseContainerEdit from './edit/ExerciseContainerEdit';
import { Button, Grid, Icon } from 'semantic-ui-react';
import { connect } from "react-redux";
import { expect, validateForm } from "../../utils/Validator";
import { IBlocGroup, BlocGroupClass} from './classes';
import { api } from "../../config/axiosConfig";
import { isEmpty } from 'lodash';
import { RouteComponentProps } from 'react-router';
import { State } from '../../reducers';
import './style/exerciseCreator.css';
import _ from 'lodash';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ExerciseCreatorState{
    blocGroupContainer: IBlocGroup[];
    currentId:number;
    errors: any;
    title: string;
    subtitle?:string;
    img?:string;
    desc: string;
    type:string;
    subtype:string;
    id?:number;
    isAdmin:boolean;
    hangboard: string;
    intensityType: string;
}
interface exerciseCreatorProps extends RouteComponentProps, WithTranslation{
    isAdmin: boolean;
};
const mapStateToProps = (state: State) => ({
    isAdmin: state.authentication.user.role.isAdmin,
});
class ExerciseCreator extends React.Component<exerciseCreatorProps,ExerciseCreatorState>{ 
    constructor(props : exerciseCreatorProps){
        super(props); 
        const defaultState: ExerciseCreatorState= {
            blocGroupContainer: [] as any,
            currentId:  0,
            title: '',
            desc:  '',
            type: '',
            subtype: '',
            intensityType: 'absolute',
            isAdmin:false,
            errors:{
                title:false,
                desc:false,
                subtype:false
            },
            hangboard: 'beastmaker2000'
        }
        if(props.location.state != undefined && (props.location.state as any).blocGroupContainer){
            const locationState = props.location.state as any;
            this.state = {
                id: locationState.id,
                blocGroupContainer:this.generateGroupBloc(locationState.blocGroupContainer) ,
                currentId: locationState.blocGroupContainer.length - 1,
                title: locationState.title,
                desc: locationState.desc,
                subtype: locationState.subtype,
                intensityType: locationState.intensityType,
                type:'mine',
                isAdmin: false,
                errors: defaultState.errors,
                hangboard: locationState.hangboard
            }
            
        }
        else {
            this.state={
                blocGroupContainer:  [new BlocGroupClass({id:0, updateState: this.updateBlocs, delete: this.deleteGroupBloc})],
                currentId: defaultState.currentId,
                title:defaultState.title,
                desc: defaultState.desc,
                type:'mine',
                subtype: defaultState.subtype,
                errors: defaultState.errors,
                isAdmin:defaultState.isAdmin,
                hangboard: defaultState.hangboard,
                intensityType: defaultState.intensityType,
            }
            // Initialize the first bloc group after state is set
            setTimeout(() => {
                this.state.blocGroupContainer[0].addBloc('hang');
                this.state.blocGroupContainer[0].addBloc('rest');
            }, 0);
        }
        this.deleteGroupBloc = this.deleteGroupBloc.bind(this);
        this.updateBlocs = this.updateBlocs.bind(this);
        this.handleInputChanges = this.handleInputChanges.bind(this);
        this.updateIndex = this.updateIndex.bind(this);
    }
    componentDidMount(){
        this.updateIndex();
        if(this.props.isAdmin && this.props.location.state && (this.props.location.state as any).createFeaturedWorkout)
            this.setState({isAdmin:true});
    }
    generateGroupBloc = (blocGroupContainer: [IBlocGroup]) => 
        blocGroupContainer.map((blocGroup: IBlocGroup) =>
            new BlocGroupClass({id: blocGroup.id, multiplier: blocGroup.multiplier, updateState: this.updateBlocs, delete: this.deleteGroupBloc, blocs:blocGroup.blocs})
    )
    private validations = [
        expect("title").required(),
        expect("subtype").required(),
    ];

    deleteGroupBloc = (groupId?) => {
        const blocGroupIndex = this.state.blocGroupContainer.findIndex(group=>group.id == groupId)

        if (blocGroupIndex == 0 && this.state.blocGroupContainer.length == 1) {
            this.setState(({ blocGroupContainer }) =>{
                blocGroupContainer.splice(blocGroupIndex, 1);
                return {blocGroupContainer};
            });
        } else if (blocGroupIndex == 0) {
            this.setState(({ blocGroupContainer }) =>{
                blocGroupContainer.splice(blocGroupIndex, 2);
                return {blocGroupContainer};
            });
        } else {
            this.setState(({ blocGroupContainer }) =>{
                blocGroupContainer.splice((blocGroupIndex - 1), 2);
                return {blocGroupContainer};
            }); 
        }
        this.updateIndex();
    }

    updateBlocs = (newBlocGroup?: IBlocGroup) => {
        const blocGroupIndex = this.state.blocGroupContainer.findIndex(group=>group.id == newBlocGroup.id)
        this.setState(({ blocGroupContainer }) => {
            blocGroupContainer[blocGroupIndex] = newBlocGroup
            return {blocGroupContainer}
        });
    }

    addBlocGroup = () => {
        this.setState(({ blocGroupContainer, currentId}) => {
            if (this.state.blocGroupContainer.length > 0) {
                let restBetweenSets;
                //Copy last rest between sets if there is one
                if (this.state.blocGroupContainer.length != 1) {
                    let lastRest = this.state.blocGroupContainer[this.state.blocGroupContainer.length - 2];
                    const newRest = _.cloneDeep(lastRest.blocs);
                    restBetweenSets = new BlocGroupClass({id: currentId+1, multiplier: null, blocs: newRest, updateState: this.updateBlocs, delete: this.deleteGroupBloc});
                    currentId += 1;
                } else {
                    restBetweenSets = new BlocGroupClass({id: currentId+1, multiplier: null, updateState: this.updateBlocs, delete: this.deleteGroupBloc});
                    restBetweenSets.addBloc("rest");
                    restBetweenSets.blocs[0].time = 120;
                    currentId += 1;
                }

                //Copy last set if there is one
                const lastSet = this.state.blocGroupContainer[this.state.blocGroupContainer.length - 1];
                const newBlocs = _.cloneDeep(lastSet.blocs);
                let newBlocGroup = new BlocGroupClass({id: currentId+1, multiplier: lastSet.multiplier, blocs: newBlocs, updateState: this.updateBlocs, delete: this.deleteGroupBloc});
                currentId += 1;

                blocGroupContainer.push(restBetweenSets);
                blocGroupContainer.push(newBlocGroup);
            
            //Case where user deleted everything from his workout
            } else {
                let newBlocGroup = new BlocGroupClass({id: currentId, updateState: this.updateBlocs, delete: this.deleteGroupBloc});
                newBlocGroup.addBloc("hang");
                newBlocGroup.addBloc("rest");

                blocGroupContainer.push(newBlocGroup);
            }
            
            return { blocGroupContainer, currentId };
        });
        this.updateIndex();
    }
    updateIndex =()=>{
        this.setState(({blocGroupContainer})=>{
            blocGroupContainer.filter((blocGroup)=>(blocGroup.blocs[0] as any).intensity && blocGroup.blocs.length >1).
            forEach((blocGroup, index)=>{
                blocGroup.setIndex(index);
            });
            return {blocGroupContainer};
        });
    }
    handleInputChanges =(input:{value:string, id:string})=>{
        switch (input.id) {
            case 'inputTitle':
                return this.setState({title:input.value});
            case 'inputSubtitle':
                return this.setState({subtitle : input.value});
            case 'inputDesc':
                return this.setState({desc : input.value});
            case 'inputImg':
                return this.setState({img : input.value});
            case 'workoutSubtype':
                return this.setState({subtype: input.value});
            case 'workoutType':
                return this.setState({type :input.value});
            case 'hangboardDropdown':
                return this.setState({hangboard: input.value});
            case 'intensityType':
                return this.setState({ intensityType: input.value });
        }
        
    }
    generateTitle = () => {
        let title;
        (this.props.location.state != undefined && (this.props.location.state as any).blocGroupContainer) ?
            title = this.props.t('title.editExercise') :
            title = this.props.t('title.newExercise');
        return title;
    }
    saveWorkout=()=>{
        let errors = validateForm(this.state, this.validations);
        if(isEmpty(errors)){
            if(this.state.id !== undefined){
                api()
                .put(`/v1/workoutWeb/${this.state.id}`, { ...this.state })
                .then(() => {
                    this.props.history.push('/');
                })
                .catch((error) => { console.log('error updating workout') });
            }
            else{
                const requestURL = this.state.isAdmin? '/v1/workoutWeb/uploadFeaturedWorkout': '/v1/workoutWeb/upload';
                api()
                .post(requestURL, { ...this.state})
                .then(() => {
                    this.props.history.push('/');
                })
                .catch((error) => { console.log('error uploading workout') });
            }
        }
        else
            this.setState({errors: errors});
    }
    render() {
        return (
            <div style={{marginRight:"inherit"}}>
                <h1 className='mainTitle'>{this.generateTitle()}</h1>
                <GeneralForm state= {this.state} handleInputChanges={this.handleInputChanges} errors={this.state.errors}/>
                <h1 className='setTitle'>{this.props.t('title.sets')}</h1>
                <ExerciseContainerEdit blocGroupContainer={this.state.blocGroupContainer} hangboard={this.state.hangboard} isAdmin={this.state.isAdmin} intensityType={this.state.intensityType} />
                <Grid >
                        <Grid.Column width={10}>
                            <Button className='btn-addSet' onClick={() => this.addBlocGroup()}> 
                                <Icon name='plus' size='large'></Icon>
                                {this.props.t('btn.addSet').toUpperCase()}
                            </Button>
                        </Grid.Column>
                        <Grid.Column className='btn-save-column' width={6} >
                            <Button className='btn-save' onClick={() => this.saveWorkout()}>  {this.props.t('btn.save').toUpperCase()} </Button>
                        </Grid.Column>                 
                </Grid>
                
            </div>
        );
    }
}


export default withTranslation('exerciseCreator')(connect(mapStateToProps) (ExerciseCreator));